import React from 'react';

const FlagAn = props => (
  <svg xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="-27 -14 54 36" {...props}>
    <path fill="#fff" d="M-27-14h54v36h-54z" />
    <path fill="#dc171d" d="M-6-14H6v36H-6z" />
    <path fill="#012a87" d="M-27-2h54v12h-54z" />
    <g id="s67c630d5" fill="#fff" transform="scale(1.5)">
      <g id="s9818fb11">
        <path id="s87e52a8c" transform="rotate(18 3.157 -.5)" d="M0 0v1h.5z" />
        <use xlinkHref="#s87e52a8c" transform="scale(-1 1)" />
      </g>
      <use xlinkHref="#s9818fb11" transform="rotate(72)" />
      <use xlinkHref="#s9818fb11" transform="rotate(-72)" />
      <use xlinkHref="#s9818fb11" transform="rotate(144)" />
      <use xlinkHref="#s9818fb11" transform="rotate(-144)" />
    </g>
    <g id="s20030a88">
      <use xlinkHref="#s67c630d5" transform="translate(8 3.314)" />
      <use xlinkHref="#s67c630d5" transform="translate(3.314 8)" />
    </g>
    <use xlinkHref="#s20030a88" transform="scale(-1 1)" />
  </svg>
);

export default FlagAn;
